import React, { useState } from "react";
import { MessageSquare, Scale } from "lucide-react";
import AIModal from "./AIModal";
import LegalSearchBlock from "./LegalSearchBlock";

const HeroButtons: React.FC = () => {
  const [isAIModalOpen, setIsAIModalOpen] = useState(false);

  const handleForumClick = () => {
    // Link to existing Discourse forum
    const forumUrl =
      process.env.REACT_APP_DISCOURSE_FORUM_URL ||
      "https://forum.commandlegacy.us/";
    console.log("Forum button clicked, redirecting to:", forumUrl);
    window.open(forumUrl, "_blank");
  };

const handleLegalSearchClick = () => {
  console.log("Legal Search clicked, opening Maryland Law Assistant");
  setIsAIModalOpen(true);
};

  const closeAIModal = () => {
    setIsAIModalOpen(false);
  };

  return (
    <>
      <div className="px-6 py-8 space-y-6">
        {/* Forum Button */}
        <button
          onClick={handleForumClick}
          className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 active:from-blue-800 active:to-blue-900 transition-all duration-200 transform active:scale-95 rounded-2xl p-8 text-left group touch-target no-select"
          style={{ minHeight: "120px" }}
        >
          <div className="flex items-center space-x-4">
            <div className="bg-white/20 p-4 rounded-xl group-hover:bg-white/30 transition-colors">
              <MessageSquare className="h-8 w-8 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-white mb-2">Forum</h3>
              <p className="text-blue-100 text-sm leading-relaxed">
                Join discussions with fellow law enforcement professionals
              </p>
            </div>
            <div className="text-white/60 group-hover:text-white/80 transition-colors">
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </button>

        {/* Legal Search Button */}
       <LegalSearchBlock />
      </div>

      {/* AI Modal for Maryland Law Assistant */}
      <AIModal isOpen={isAIModalOpen} onClose={closeAIModal} />
    </>
  );
};

export default HeroButtons;
